import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import Reveal from "./Reveal";
import { track } from "../lib/analytics";

const QUICK_FAQS = [
  {
    q: "Is the trial really card-free?",
    a: "Yes. 3 full days, free. Card is required at checkout — we use Stripe — but you won't be charged until the trial ends, and you can cancel anytime before then.",
  },
  {
    q: "Does the AI actually remember me?",
    a: "Yes. Your roadmap, your goals across the five pillars, and the context of past conversations are all persistent. No re-explaining.",
  },
  {
    q: "Is this therapy or medical care?",
    a: "No. Ascend Higher is for personal growth, organization, reflection and habit-building — not therapy, medical advice, or crisis support. Crisis? Call/text 988 (US).",
  },
  {
    q: "What's the difference between Basic and Advanced?",
    a: "Basic ($8.88/mo) is text coaching + roadmap + habits. Advanced ($28.88/mo) adds voice calls, deeper memory, weekly insights, and 10× the daily message budget.",
  },
  {
    q: "Can I cancel anytime?",
    a: "Yes. One click from the Pricing page or by emailing support. You keep access until the end of your billing cycle.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="py-24 md:py-32 bg-[#f7f3ea]">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <div className="text-center mb-14">
            <p className="font-mono-eyebrow text-[#486a8f] mb-4">Frequently asked</p>
            <h2 className="font-display text-[40px] md:text-[56px] leading-[1.05] tracking-tight text-[#0f1724]">
              Honest answers,{" "}
              <span className="italic font-light text-[#486a8f]">no fluff.</span>
            </h2>
          </div>
        </Reveal>
        <Reveal>
          <div className="rounded-2xl bg-white border border-[#eadfc9] overflow-hidden">
            {QUICK_FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className={i > 0 ? "border-t border-[#eadfc9]" : ""}>
                  <button
                    data-testid={`landing-faq-${i}`}
                    onClick={() => {
                      setOpen(isOpen ? -1 : i);
                      if (!isOpen) track("landing_faq_opened", { question_index: i });
                    }}
                    className="w-full text-left p-6 flex items-start justify-between gap-6 hover:bg-[#faf6ec] transition-colors"
                  >
                    <span className="font-display text-[18px] text-[#0f1724] tracking-tight leading-tight">
                      {f.q}
                    </span>
                    <span className="w-7 h-7 rounded-full bg-[#f2ecdc] flex items-center justify-center shrink-0 text-[#486a8f]">
                      {isOpen ? <Minus size={13} /> : <Plus size={13} />}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-6 -mt-2">
                      <p className="font-body text-[14px] text-[#4b5563] leading-relaxed">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
        <div className="text-center mt-8">
          <a href="/faq" className="font-body text-[14px] text-[#486a8f] hover:underline">
            See all questions →
          </a>
        </div>
      </div>
    </section>
  );
}
